import { useSelector } from 'react-redux';
import { isEmpty, transform } from 'lodash-es';
import { IntercomProps, useIntercom } from 'react-use-intercom';
import { getICData } from '../../../store/account/actions';

export const useUpdateIntercom = (): void => {
    const account = useSelector(getICData);
    const { update } = useIntercom() || {};

    const { Email, SecondaryHash, Firstname, Lastname, DateCreated, ...restOfAttributes } = account;

    const customAttributes = transform(restOfAttributes, (result: any, val: any, key: string) => {
        result[key.toLowerCase()] = val;
    });

    const intercomPayload: Partial<IntercomProps> = {
        email: Email,
        userHash: SecondaryHash,
        name: `${Firstname} ${Lastname}`,
        createdAt: DateCreated,
        customAttributes,
    };

    if (isEmpty(account)) {
        return;
    }

    try {
        update(intercomPayload);
        // eslint-disable-next-line no-empty
    } catch {}
};

export default useUpdateIntercom;
